"use strict";

var CLA = {
  KUSAMA: 0x99,
  POLKADOT: 0x90
}; // https://github.com/satoshilabs/slips/blob/master/slip-0044.md

var SLIP0044 = {
  KUSAMA: 0x800001b2,
  POLKADOT: 0x80000162
};
module.exports = {
  CLA: CLA,
  SLIP0044: SLIP0044
};